import React, { createContext, useState } from 'react';

const AssetContext = createContext();

const initialState = {
  id:0,
  title: '',
  titleError: false,
  description: '',
  descriptionError: false,
  descriptionTitle: 'Description',
  descriptionTitleError: false,
  category: [],
  categoryOptions: [],
  categorySelected: '',
  categoryCode: '',
  categorySelectedError: false,
  reviewerOptions: [],
  reviewerIds: [],
  reviewerIdsError: false,
  // Edit only: reviewers already on the artifact, and those with review activity
  // (comment/approve/reject) who can't be unselected.
  assignedReviewers: [],
  lockedReviewerIds: [],
  assetFileData: null,
  step1Error: true,
  assetZipFile: '',
  tags: [],
  contentInputMethod: 'upload',
  manualContent: null,
  manualContentError: false,
};

export const AssetProvider = ({ children }) => {
  const [assetForm, setAssetForm] = useState(initialState);
  const [userRole,setUserRole] = useState(false)
  const [userBusinessUnit,setUserBusinessUnit] = useState(false)

  return (
    <AssetContext.Provider value={{ assetForm, userRole,userBusinessUnit, setUserBusinessUnit, assetInitialState:initialState, setUserRole,setAssetForm, resetAssetForm: () => setAssetForm(initialState) }}>
      {children}
    </AssetContext.Provider>
  );
};

export default AssetContext;
